// Картинки вкусов. Кладём файл `assets/flavors/<slug>.png` — он подхватывается
// автоматически (Vite glob), без ручной регистрации. Для вкусов без картинки
// компонент показывает запасной вариант (эмодзи на пастельном фоне).
//
// Источник — плоские AI-иллюстрации из макета (не фото, без копирайта).
// Покрыты пока не все 47 вкусов; недостающие просто дропнуть в ту же папку.

const modules = import.meta.glob('../assets/flavors/*.{png,jpg,jpeg,webp}', {
  eager: true,
  import: 'default',
}) as Record<string, string>

const BY_SLUG: Record<string, string> = {}
for (const [path, url] of Object.entries(modules)) {
  const file = path.split('/').pop() ?? ''
  const slug = file.replace(/\.\w+$/, '')
  BY_SLUG[slug] = url
}

/** URL картинки вкуса или undefined, если её ещё нет. */
export const getFlavorImage = (slug: string): string | undefined => BY_SLUG[slug]
